import indexBimestrais from "@/Pages/Acompanhamentos/AcompanhamentosBimestrais/index.vue";
import newEditAcompanhamentosBimestrais from "@/Pages/Acompanhamentos/AcompanhamentosBimestrais/newEditAcompanhamentosBimestrais.vue";

import indexAnaliseEConsolidado from "@/Pages/Acompanhamentos/AnaliseEConsolidado/index.vue";
import newEditAnaliseEConsolidado from "@/Pages/Acompanhamentos/AnaliseEConsolidado/newEditAnaliseEConsolidado.vue";

export default [
  {
    path: "/acompanhamentos-bimestrais",
    name: "acompanhamentosBimestrais",
    component: indexBimestrais,
  },
  {
    path: "/acompanhamentos-bimestrais-create/:gestaoDeAulaId/:disciplinaId",
    name: "acompanhamentosBimestrais.newEdit",
    component: newEditAcompanhamentosBimestrais,
    props: { editing: false },
  },
  {
    path: "/acompanhamentos/:acompanhamentoId",
    name: "acompanhamentos.edit",
    component: newEditAcompanhamentosBimestrais,
    props: { editing: true },
  },

  {
    path: "/acompanhamentos-analise-e-consolidados",
    name: "acompanhamentosAnaliseEConsolidados",
    component: indexAnaliseEConsolidado,
  },
  {
    path: "/acompanhamentos-analise-e-consolidados-create/:professorId",
    name: "acompanhamentosAnaliseEConsolidados.newEdit",
    component: newEditAnaliseEConsolidado,
    props: { editing: false },
  },
  {
    path: "/acompanhamentos-analise-e-consolidados/:acompanhamentoId",
    name: "acompanhamentosAnaliseEConsolidados.edit",
    component: newEditAnaliseEConsolidado,
    props: { editing: true },
  },
  // {
  //   path: "/gestoes-de-aulas-aee-relatorio/:gestaoId",
  //   name: "gestoesAEERelatorio.newEdit",
  //   component: relatorioAEE,
  // },
];
